export default "__VITE_ASSET__9f1b9fbc__"